import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getAllVariantsWithFilters } from "../../actions/variantActions";
import { addSearchKeywordToFilters } from "../../actions/variantFilterActions";
import { useQuery } from "react-query";
import { searchVariants } from "../../api/queries/variants/variantsApi";
const imageSrc = process.env.REACT_APP_API_URL + "/uploads/variant_images/";
export default function Search() {
  const [keysearch, setKeysearch] = useState();
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const { isLoading, isError, data, error } = useQuery(
    ["searchVariants", searchTerm],
    async () => {
      if (searchTerm.length > 2) {
        return await searchVariants(searchTerm);
      }
      return [];
    }
  );

  useEffect(() => {
    !isLoading && setProducts(data);
  }, [isLoading]);

  const handleSearch = (e) => {
    let value = e.target.value;
    setSearchTerm(value);
  };
  const closeSearch = () => {
    setSearchTerm("");
  };
  return (
    <>
      <form action="#" autoComplete="off">
        <div className="header-search-wrapper search-wrapper-wide">
          {/* <label htmlFor="q" className="sr-only">
            Chercher
          </label> */}
          <input
            type="search"
            className="form-control"
            name="q"
            id="q"
            placeholder="Cherchez un produit"
            onChange={handleSearch}
            value={searchTerm}
          />

          {searchTerm && (
            <i
              className="search-input icon-close"
              onClick={() => closeSearch()}
            ></i>
          )}

          {isLoading && (
            <span
              style={{
                position: "absolute",
                fontSize: "1.5rem",
                margin: "auto",
                right: "30%",
                display: "inline-block",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              Recherche...
            </span>
          )}
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              dispatch(addSearchKeywordToFilters(keysearch));
              dispatch(getAllVariantsWithFilters());
            }}
          >
            <i className="icon-search"></i>
          </button>
        </div>
      </form>

      {products.length && searchTerm.length >= 2 && (
        <div className="searchResult">
          <ul>
            {searchTerm.length >= 2 &&
              products
                .filter((val) => {
                  return val.nameFr
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
                })
                .map((val) => {
                  return (
                    <li>
                      <Link
                        to={"/product/default/" + val.id}
                        key={val.id}
                        onClick={() =>
                          (window.location.href = "/product/default/" + val.id)
                        }
                      >
                        <img src={imageSrc + val._fileName} alt="" />
                        {val.nameFr}
                      </Link>
                    </li>
                  );
                })}
          </ul>
        </div>
      )}
    </>
  );
}
